<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div slot="no-body">
		<vs-navbar
			v-model="activeItem"
			color="primary"
			text-color="rgba(255,255,255,.6)"
			active-text-color="rgba(255,255,255,1)"
			class="myNavbar cursor-pointer"
		>
			<vs-navbar-item :index="0">
				<a :class="activeItem === 0 ? 'font-bold' : 'font-semibold'">
					{{ $t("TimeWindow.DayOfWeek") }}
				</a>
			</vs-navbar-item>
			<vs-navbar-item :index="1">
				<a :class="activeItem === 1 ? 'font-bold' : 'font-semibold'">
					{{ $t("TimeWindow.DayOfMonth") }}
				</a>
			</vs-navbar-item>
			<vs-navbar-item :index="2">
				<a :class="activeItem === 2 ? 'font-bold' : 'font-semibold'">
					{{ $t("TimeWindow.Month") }}
				</a>
			</vs-navbar-item>
			<vs-navbar-item :index="3">
				<a :class="activeItem === 3 ? 'font-bold' : 'font-semibold'">
					{{ $t("TimeWindow.Hours") }}
				</a>
			</vs-navbar-item>
			<vs-navbar-item :index="4">
				<a :class="activeItem === 4 ? 'font-bold' : 'font-semibold'">
					{{ $t("TimeWindow.Minutes") }}
				</a>
			</vs-navbar-item>
		</vs-navbar>
		<transition name="fade">
			<div class="tab-text" v-show="activeItem === 0">
				<day-week
					:is-edit="true"
					:cronExpressionDayWeek="dataTimeWindow.cron.split(' ')[4]"
					@resultDayWeekEmit="resultDayWeek"
				/>
			</div>
		</transition>
		<transition name="fade">
			<div class="tab-text" v-show="activeItem === 1">
				<day-month
					:is-edit="true"
					:cronExpressionDayMonth="dataTimeWindow.cron.split(' ')[2]"
					@resultDayMonthEmit="resultDayMonth"
				/>
			</div>
		</transition>
		<transition name="fade">
			<div class="tab-text" v-show="activeItem === 2">
				<Monthly
					:is-edit="true"
					:cronExpressionMonth="dataTimeWindow.cron.split(' ')[3]"
					@resultMonthEmit="resultMonth"
				/>
			</div>
		</transition>
		<transition name="fade">
			<div class="tab-text" v-show="activeItem === 3">
				<hourly
					:is-edit="true"
					:cronExpressionHour="dataTimeWindow.cron.split(' ')[1]"
					@resultHourEmit="resultHour"
				/>
			</div>
		</transition>
		<transition name="fade">
			<div class="tab-text" v-show="activeItem === 4">
				<minute
					:is-edit="true"
					:cronExpressionMinute="dataTimeWindow.cron.split(' ')[0]"
					@resultMinuteEmit="resultMinute"
				/>
			</div>
		</transition>
		<div
			v-if="!isSoftTimeWindow"
			class="flex items-center justify-between p-2 mt-2"
			style="border: 1px solid #ccc; border-radius: 5px"
		>
			<h5>{{ $t("TimeWindow.SoftTimeWindow") }}</h5>
			<vs-button
				class="font-bold"
				icon-pack="feather"
				icon="icon-plus"
				type="flat"
				size="small"
				@click.prevent="addSoftTimeWindow()"
				><small style="font-size: 13px">{{ $t("Teams.Form.Add") }}</small>
			</vs-button>
		</div>
		<vx-card v-else class="mt-2" :title="$t('TimeWindow.SoftTimeWindow')" :cardBorder="true" :noShadow="true">
			<template slot="actions">
				<feather-icon
					icon="Trash2Icon"
					svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
					:title="$t('Crud.Delete') + ' ' + $t('TimeWindow.SoftTimeWindow')"
					@click.prevent="deleteSoftTimeWindow()"
				/>
			</template>
			<form>
				<div class="vx-row">
					<span
						class="text-danger text-sm pt-2 pb-2 pl-4 pr-4"
						v-if="
							compareDurations(
								this.dataTimeWindow.duration,
								dataTimeWindow.before_soft_duration,
								dataTimeWindow.after_soft_duration
							)
						"
						>{{ $t("TimeWindow.TheSumOfTheInitialDurationAndTheFinalDuration") }}</span
					>
					<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
						<small class="date-label">{{ $t("TimeWindow.Duration") + " " + $t("Initial") }}</small>
						<flat-pickr
							class="w-full"
							v-model="dataTimeWindow.before_soft_duration"
							name="dataHourInitSoftWindow"
							:config="configdateTimePicker"
							:placeholder="$t('Select')"
						/>
					</div>
					<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
						<small class="date-label">{{ $t("TimeWindow.Duration") + " " + $t("End") }}</small>
						<flat-pickr
							v-model="dataTimeWindow.after_soft_duration"
							class="w-full"
							name="dataHourEndSoftWindow"
							:placeholder="$t('Select')"
							:config="configdateTimePicker"
						/>
					</div>
				</div>
				<div class="vx-row">
					<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
						<small class="date-label">{{ $t("TimeWindow.PenaltyForAnticipation") }}</small>
						<vs-input
							type="number"
							class="w-full"
							v-model="dataTimeWindow.before_soft_cost"
							name="penaltyForAnticipation"
							@blur="validatePerCost()"
							@keypress="validateAmountNumber"
						/>
					</div>
					<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
						<small class="date-label">{{ $t("TimeWindow.PenaltyForLateness") }}</small>
						<vs-input
							type="number"
							class="w-full"
							v-model="dataTimeWindow.after_soft_cost"
							name="penaltyForLateness"
							@blur="validatePerCost()"
							@keypress="validateAmountNumber"
						/>
					</div>
				</div>
			</form>
		</vx-card>
	</div>
</template>

<script>
import Utils from "@/helpers/Utils";
import {generalPurposeMixin} from "@/mixins/generalPurposeMixin.js";
import {FormWizard, TabContent} from "vue-form-wizard";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

export default {
	name: "TimeWindowEditCron",
	mixins: [generalPurposeMixin],
	components: {
		FormWizard,
		TabContent,
		vSelect,
		flatPickr,
	},
	props: {
		dataTimeWindow: {
			type: Object,
			default: "",
		},
	},
	data() {
		return {
			activeTab: 0,
			cronDayWeek: "*",
			cronDayMonth: "*",
			cronMonth: "*",
			cronHour: "0",
			cronMinute: "0",
			activeItem: 0,
			isSoftTimeWindow: false,
			configdateTimePicker: {
				enableTime: true,
				enableSeconds: true,
				noCalendar: true,
				dateFormat: "H:i:ss",
				time_24hr: true,
			},
		};
	},
	computed: {
		cronExpression() {
			return `${this.cronMinute} ${this.cronHour} ${this.cronDayMonth} ${this.cronMonth} ${this.cronDayWeek}`;
		},
		timeToMilliseconds() {
			return (time) => {
				const [hours, minutes, seconds] = time ? time.split(":").map(Number) : "00:00:00";
				return hours * 60 * 60 * 1000 + minutes * 60 * 1000 + seconds * 1000;
			};
		},
	},
	mounted() {
		if (
			this.dataTimeWindow.before_soft_duration != null &&
			this.dataTimeWindow.after_soft_duration != null &&
			this.dataTimeWindow.before_soft_cost != null &&
			this.dataTimeWindow.after_soft_cost != null
		) {
			this.isSoftTimeWindow = true;
			this.$emit("isSoftTimeWindowEmit", true);
		} else {
			this.dataTimeWindow.before_soft_duration = "00:00:00";
			this.dataTimeWindow.after_soft_duration = "00:00:00";
			this.dataTimeWindow.before_soft_cost = 0;
			this.dataTimeWindow.after_soft_cost = 0;
		}
		this.getEvents(this.dataTimeWindow.cron);
	},
	watch: {
		cronDayMonth(newVal) {
			if (this.dataTimeWindow.cron.split(" ")[2] !== newVal) this.getEvents(this.cronExpression);
		},
		cronDayWeek(newVal) {
			if (this.dataTimeWindow.cron.split(" ")[4] !== newVal) this.getEvents(this.cronExpression);
		},
		cronMonth(newVal) {
			if (this.dataTimeWindow.cron.split(" ")[3] !== newVal) this.getEvents(this.cronExpression);
		},
		cronHour(newVal) {
			if (this.dataTimeWindow.cron.split(" ")[1] !== newVal) this.getEvents(this.cronExpression);
		},
		cronMinute(newVal) {
			if (this.dataTimeWindow.cron.split(" ")[0] !== newVal) this.getEvents(this.cronExpression);
		},
		cronExpression(val) {
			this.dataTimeWindow.cron = val;
		},
		dataTimeWindow(val) {
			if (val.hasOwnProperty("soft_time_window")) {
				this.dataTimeWindow.before_soft_duration = this.dataTimeWindow.soft_time_window.before_soft_duration;
				this.dataTimeWindow.after_soft_duration = this.dataTimeWindow.soft_time_window.after_soft_duration;
				this.dataTimeWindow.before_soft_cost = this.dataTimeWindow.soft_time_window.before_soft_cost;
				this.dataTimeWindow.after_soft_cost = this.dataTimeWindow.soft_time_window.after_soft_cost;
			}
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		resultDayMonth(val) {
			this.cronDayMonth = val;
			this.$store.commit("moduleTimeWindow/SET_CRON_EXPRESSION", this.cronExpression);
		},
		resultDayWeek(val) {
			this.cronDayWeek = val;
			this.$store.commit("moduleTimeWindow/SET_CRON_EXPRESSION", this.cronExpression);
		},
		resultMonth(val) {
			this.cronMonth = val;
			this.$store.commit("moduleTimeWindow/SET_CRON_EXPRESSION", this.cronExpression);
		},
		resultHour(val) {
			this.cronHour = val;
			this.$store.commit("moduleTimeWindow/SET_CRON_EXPRESSION", this.cronExpression);
		},
		resultMinute(val) {
			this.cronMinute = val;
			this.$store.commit("moduleTimeWindow/SET_CRON_EXPRESSION", this.cronExpression);
		},
		addDaysToDate(stringDate, dayNums) {
			const date = new Date(stringDate);
			return date.setDate(date.getDate() + dayNums);
		},
		getEvents(cron) {
			let payload = {
				init_date: this.dateInitComputed,
				end_date: this.dateFinalComputed,
				end_hour: "23:59:59",
				init_hour: "00:00:00",
				time_windows: [
					{
						cron_exp: cron,
						duration: this.dataTimeWindow.duration,
						...(this.isSoftTimeWindow
							? {
									soft_time_window: {
										before_soft_duration: this.dataTimeWindow.before_soft_duration,
										after_soft_duration: this.dataTimeWindow.after_soft_duration,
									},
							  }
							: {}),
					},
				],
			};
			this.$store
				.dispatch("moduleTimeWindow/findTimeWindowSimulate", payload)
				.then((res) => {
					if (res.data[0] === "invalid cron expression") {
						this.$vs.notify({
							color: "warning",
							title: this.$t("TimeWindow.Schedule"),
							text: this.$t("TimeWindow.TheChosenTimeIsNotValid"),
							time: 7000,
						});
					}
					return res;
				})
				.catch((err) => {
					console.error(err);
				});
		},
		validateAmountNumber(event) {
			let regex = /^\d+$/;
			let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
			if (!regex.test(key)) {
				event.preventDefault();
				return false;
			}
		},
		compareDurations(durationTimeWindow, durationSoftTimeWindow1, durationSoftTimeWindow2) {
			// Convertir las horas a milisegundos
			const durationTimeWindowMs = this.timeToMilliseconds(durationTimeWindow);
			const durationSoftTimeWindow1Ms = this.timeToMilliseconds(durationSoftTimeWindow1);
			const durationSoftTimeWindow2Ms = this.timeToMilliseconds(durationSoftTimeWindow2);
			const sumMs = durationSoftTimeWindow1Ms + durationSoftTimeWindow2Ms;
			if (this.isSoftTimeWindow) {
				if (
					sumMs <= durationTimeWindowMs &&
					this.dataTimeWindow.before_soft_duration != "" &&
					this.dataTimeWindow.after_soft_duration != ""
				) {
					this.getEvents(this.cronExpression);
				}
				this.$emit("compareDurationEmit", sumMs > durationTimeWindowMs);
			}
			return sumMs > durationTimeWindowMs;
		},
		addSoftTimeWindow() {
			this.isSoftTimeWindow = true;
			this.$emit("isSoftTimeWindowEmit", true);
		},
		deleteSoftTimeWindow() {
			this.isSoftTimeWindow = false;
			this.$emit("isSoftTimeWindowEmit", false);
			this.getEvents(this.cronExpression);
		},
		// Método para validar los campos específicos
		validatePerCost() {
			if (this.dataTimeWindow) {
				Utils.checkZero("before_soft_cost", this.dataTimeWindow);
				Utils.checkZero("after_soft_cost", this.dataTimeWindow);
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.vs-navbar-gradient .vs-navbar-item-primary.is-active-item {
	border-radius: 6px;
	color: #fff !important;
	background: rgba(var(--vs-primary), 1);
}

.vs-navbar {
	-webkit-box-shadow: none;
	box-shadow: none;
}

.vs-navbar-gradient {
	border: 1px solid rgba(0, 0, 0, 0.05);
}

.vs-navbar-gradient .vs-navbar--item {
	border-left: 1px solid rgba(0, 0, 0, 0.05);
}
</style>
